import JoinPageConnect from "./components/connect/join-page-connect"
import createComponent from "@/utils/create-component"

export default () => {
  const el = document.getElementById("vue-organisations-connect")

  if (!el) {
    // prevent trying to mount the component when in another page
    return
  }

  const { categoryProps, inviterName } = el.dataset

  createComponent({
    el: el,
    component: JoinPageConnect,
    props: {
      categoryProps: JSON.parse(categoryProps),
      inviterName: inviterName
    }
  })
}
